import React, { useState, useEffect } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import { NotFound, Project, Projects, Quote, Services, Single } from '../../modules/';
import App from '../../App';
import { Header, Footer } from '../../library/common/components';
import '../../resources/styles/styles.scss';

const routes = [
  { path: "/", name: "Home", Component: App, exact: true },
  { path: "/quote", name: "Cotizador", Component: Quote, exact: false },
  { path: "/services", name: "Servicios", Component: Services, exact: true },
  { path: "/services/:id", name: "Descripción del servicio", Component: Single, exact: true },
  { path: "/projects", name: "Proyectos", Component: Projects, exact: true },
  { path: "/projects/:id", name: "Descipción del proyecto", Component: Project, exact: false },
];

const AppRouter = () => {
  const [pos, setPos] = useState('top');
  const [showScroll, setShowScroll] = useState(false);

	useEffect (()=>{
		document.addEventListener('scroll', e => {
				let scrolled = document.scrollingElement.scrollTop;
				if (scrolled >= 5){
					setPos('moved')
				} else {
					setPos('top')
				}
		})
	},[]);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400){
      setShowScroll(true)
    } else if (showScroll && window.pageYOffset <= 400){
      setShowScroll(false)
    }
  };

  const scrollTop = () =>{
    window.scrollTo({top: 0, behavior: 'smooth'});
  };

  window.addEventListener('scroll', checkScrollTop)

  return (
    <HashRouter basename='/'>
      <div>
        <Header></Header>
        <div className={pos === 'top' ? 'app' : 'app-scrolled'}>
          <Switch>
            { routes.map(({ path, name, Component, exact }) => (
              <Route key={path}
                path={path}
                exact={exact}
                render={(props) => {
                  return (
                    <div className="p-8">
                      <Component {...props} />
                    </div>
                  );
                }} />
            ))}
            <Route component={NotFound} />
          </Switch>
        </div>
        <Footer></Footer>
        <div className="scrollTop" onClick={scrollTop} style={{display: showScroll ? 'flex' : 'none'}}>	
          &#8593;
        </div>
      </div>
    </HashRouter>
  );
}

export { routes, AppRouter as default };